import compact from 'lodash/compact';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {
  enrollmentInputGroup,
  error,
  inputContainer,
  subtext,
} from 'src/pages/reportIssue/components/styles.module.scss';
import {formatPhoneNumber} from 'src/shared/utils/formatPhoneNumber';
import {
  button,
  buttonGroup,
  primary,
} from 'src/styles/modules/button.module.scss';
import {
  input,
  invalid,
} from 'src/styles/modules/forms.module.scss';

export const SmsEnrollmentScreen = ({
  continueUrl,
  enrollSms,
  presetSmsNumber,
}) => {
  const [validationError, setValidationError] = useState(false);
  const [smsNumber, setSmsNumber] = useState(presetSmsNumber ? formatPhoneNumber(presetSmsNumber) : '');

  const onClick = () => {
    const formattedNumber = smsNumber.replace(/\D/g, '');
    const error = !/^\d{10,11}$/.test(formattedNumber);
    setValidationError(error);
    if (!error) {
      enrollSms(formattedNumber);
    }
  };

  return (
    <>
      <h1>There&apos;s been an issue reported in your area. We can text you when we have more details. </h1>
      <div className={enrollmentInputGroup}>
        <label htmlFor="mobileNumber">Please enter your mobile number.</label>
        <div className={inputContainer}>
          <input
            autoCapitalize="off"
            autoComplete="off"
            autoCorrect="off"
            className={compact([input, validationError && invalid]).join(' ')}
            id="mobileNumber"
            maxLength="16"
            placeholder="(###) ###-####"
            onChange={({target: {value}}) => setSmsNumber(formatPhoneNumber(value))}
            required
            type="text"
            value={smsNumber}
          />
          {
            validationError && <p className={error}>Enter a valid 10-digit phone number</p>
          }
        </div>
        <p className={subtext}>Message and data rates may apply.</p>
      </div>
      <div className={buttonGroup}>
        <button className={`${button} ${primary}`} onClick={onClick}>Get a Text</button>
        <a href={continueUrl} className={button}>Back</a>
      </div>
    </>
  );
};

SmsEnrollmentScreen.propTypes = {
  continueUrl: PropTypes.string.isRequired,
  presetSmsNumber: PropTypes.string,
  enrollSms: PropTypes.func.isRequired,
};

SmsEnrollmentScreen.defaultProps = {
  presetSmsNumber: '',
};
